﻿<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Datum podpisu</label>
    <div class="input"><input type="text" pick-a-date [(ngModel)]="data.signedAdministratorDate" [maxToday]="true"/></div>
  </div>
</fieldset>
